import { createSelector } from '@reduxjs/toolkit'

const sliceSelector = (state) => state.userGroups.management.group
export const userGroupSelector = createSelector(sliceSelector, ({ userGroup }) => userGroup)
export const isDataLoadingSelector = createSelector(sliceSelector, ({ status }) => status === 'loading')
export const activeMembershipsCountSelector = createSelector(userGroupSelector, (slice) => slice.active_group_memberships_count)
export const pendingMembershipsCountSelector = createSelector(userGroupSelector, (slice) => slice.pending_group_memberships_count)
export const migratingMembershipsCountSelector = createSelector(userGroupSelector, (slice) => slice.migrating_group_memberships_count)
export const isGroupMappingActivatedSelector = createSelector(userGroupSelector, (slice) => slice.group_mapping_state === 'activated')
